import { useEffect } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider as StoreProvider } from 'react-redux';
import { ThemeProvider } from '@nazka/nazka.mapframe.components';
import { ToastContainer, toast } from 'react-toastify';

import TranslationsProvider, { LocalizedRoutes } from '@utils/i18n/i18n';
import WindowObserver from '@utils/WindowObserver/WindowObserver';
import ErrorBoundary from '@utils/ErrorBoundary/ErrorBoundary';
import Cookies from '@utils/Cookies/Cookies';
import PWABadge from '@App/components/PWABadge/PWABadge';
import OfflineUploadQueueProvider from '@utils/OfflineUploadQueue/OfflineUploadQueueProvider';
import routes from '@App/app.routes';
import store from '@App/app.store';
import translator from '@App/app.translator';

import { useNetworkState } from '@services/hooks.service';

import theme from '@css/theme.style.json';
import GuidedTour from '@library/GuidedTour/GuidedTour';

import './app.styl';

function renderRoutes(routess) {
  return routess.map(({
    path, element, children, index, name, 
  }) => (
    <Route key={path || name} path={path} element={element} index={index}>
      {children && renderRoutes(children)}
    </Route>
  ));
}

function App() {
  useEffect(() => document.documentElement.setAttribute('data-app-initialised', true), []);
  const isOnline = useNetworkState()

  useEffect(() => {
    if (!isOnline) {
      toast.error(translator.translate('You are offline'));
    }
  }, [isOnline])

  return (
    <StoreProvider store={store}>
      <ThemeProvider theme={theme}>
        <OfflineUploadQueueProvider>
          <BrowserRouter>
            <ErrorBoundary>
              <TranslationsProvider translator={translator}>
                <LocalizedRoutes>
                  {renderRoutes(routes)}
                </LocalizedRoutes>
                <Cookies useConfig />
                <GuidedTour />
                <PWABadge />
              </TranslationsProvider>
            </ErrorBoundary>
          </BrowserRouter>
        </OfflineUploadQueueProvider>
      </ThemeProvider>
      <WindowObserver />
      <ToastContainer
        position="bottom-right"
        hideProgressBar
        autoClose={false}
      />
    </StoreProvider>
  );
}

export default App;
